import common from '../common'


const telPhoneByNumber = (phone) => {
    if( !phone ) {
        return
    }
    // 安卓
    if( !common?.isAndroid_ios() ) {
        if(window?.androidNative?.telPhoneByNumber && phone) {
            window.androidNative.telPhoneByNumber(phone)
        }
    }else {
        if( window?.webkit?.messageHandlers?.telPhoneByNumber) {
            window?.webkit.messageHandlers.telPhoneByNumber.postMessage(phone)
        }
    }
}
export default telPhoneByNumber